import React, { useState, useEffect, useContext } from "react";
import { FormGroup, SearchContainer, SearchBox, SearchLabel, DateInput, SelectBox, InputBase } from './styled';
import styled from 'styled-components';
import { AppContext } from "../../../../AppContext";
import MultiSelecter from "../../../MultiSelecter"; // 다중 선택기를 사용하기 위해 가져옴
import CustomSelectBox from '../../../SearchSelecter'; // 커스텀 선택 박스를 가져옴
import DynamicSimpleSearch from "../../../DynamicSimpleSearch";

export const DyInput = styled.input`
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-size: 16px;
`;

const SimpleSearchForm = ({ handleSearchChange, formFields, searchParams, setSearchParams, getBoardData, currentPage, postsPerPage, tableName,orderBy }) => {
  const [selectedField, setSelectedField] = useState(''); // 선택된 필드를 저장
  const [options, setOptions] = useState([]); // 선택된 필드의 옵션 저장
  const [arraySelectOptions, setArraySelectOptions] = useState([]); // 배열 입력 옵션 저장
  const { user } = useContext(AppContext);
  
  // Initialize formData state to hold input values
  const [formData, setFormData] = useState({}); // 검색 폼 데이터 상태 추가

  useEffect(() => {
    // Reset selected field and input values when formFields change
    setSelectedField('');
    setOptions([]);
    setArraySelectOptions([]);
    setFormData({}); // Clear all form data
  }, [formFields]);

  useEffect(() => {
    if (selectedField) {
      const field = formFields.find(f => f.column_id === selectedField);
      fetchOptions(field);
      if (field?.control_type === 'ArrayInput') {
        fetchArrayOptions(field);
      }
    }
  }, [selectedField]);
  useEffect(()=>{

  },[searchParams])
  const fetchOptions = async (field) => {
    if (!field) return;
    let url;
    let response;

    // Fetch options based on control type and bind key
    if (field?.control_type === 'SelectBox' && field.bind_key) {
      try {
        url = `/request/getFormControlOptions?bind_key=${field.bind_key}&bind_option=${field.bind_option}`;
        response = await fetch(url, { credentials: 'include', headers: { Accept: 'application/json' }, method: 'GET' });
        if (response.ok) {
          const data = await response.json();
          setOptions(data);
        }
      } catch (error) {
        console.error('Error fetching options:', error);
      }
    }
  };

  const fetchArrayOptions = async (field) => {
    if (!field) return;
    try {
      const response = await fetch(`/request/getOptions?target_code=${field.root_column}&code_group=${field.bind_key}`, { credentials: "include" });
      if (response.ok) {
        const data = await response.json();
        const formattedOptions = data.options.map((item) => ({
          value: item.code_value,
          label: `[ ${item.code_option} | ${item.code_value} ]`,
        }));
        setArraySelectOptions(formattedOptions);
      }
    } catch (error) {
      console.error("Error fetching array options:", error);
    }
  };

  const handleFieldChange = (event) => {
    const newField = event.target.value;
    setSelectedField(newField);

    // Clear the search value for the previous field
    setFormData(prevFormData => ({
      ...prevFormData,
      [newField]: '', // Reset the value for the new field
    }));
  };

  // Define the handleInputChange function
  const handleInputChange = (fieldId, value) => {
    //alert(fieldId + value);
    // Update formData with the new value
    setFormData((prevFormData) => ({
      ...prevFormData,
      [fieldId]: value,
    }));
    //setSearchParams((prevData)=>({...prevData,[fieldId]: value}));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // [2026-07-03] 새 검색 = 이전 필드 조건 초기화(조건 누적 버그 수정). 날짜만 유지.
    let Params = { from: searchParams?.from, to: searchParams?.to, [selectedField]: formData[selectedField] };
    if (setSearchParams) setSearchParams(Params);
    getBoardData(currentPage, postsPerPage, tableName,Params,orderBy,'SimpleSearchForm');
  };

  // [통합검색 2026-07-03] 검색어 하나로 검색가능한 모든 컬럼을 한꺼번에 OR 검색(한글 라벨 포함).
  const [qValue, setQValue] = useState('');
  const handleUnifiedSubmit = (event) => {
    if (event) event.preventDefault();
    const Params = { from: searchParams?.from, to: searchParams?.to };
    if (qValue && qValue.trim()) Params.q = qValue.trim();
    if (setSearchParams) setSearchParams(Params);
    getBoardData(currentPage, postsPerPage, tableName, Params, orderBy, 'SimpleSearchForm');
  };
  const SelectHeader = styled.div`
  border: 1px solid #ddd;
  padding: 7px 10px;
  border-radius: 4px;
  cursor: pointer;
  background-color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size:12px;
`;
  return (
    <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
      <SearchContainer>
        {/* 통합검색 — 검색어 하나로 전체 컬럼 검색 (가맹점이름·쿠폰종류 등 한글 이름 그대로).
            2026-07-03 사용자 요청: 날짜·검색조건 선택·별도 검색버튼 제거, 이 한 칸으로 단일화 */}
        <SearchBox style={{ flex: 1 }}>
          <DyInput
            type="text"
            value={qValue}
            onChange={(e) => setQValue(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter') handleUnifiedSubmit(e); }}
            placeholder="검색어 입력"
            style={{ width: '100%', fontSize: '13px', padding: '9px', boxSizing: 'border-box' }}
          />
        </SearchBox>
        <button
          style={{ flex: '0 0 auto', width: '5.5rem', fontSize: '1rem', padding: '9px 0', margin: 0 }}
          className="postingBtn" type="button" onClick={handleUnifiedSubmit}>
          검색
        </button>
      </SearchContainer>
    </div>
  );
};

export default SimpleSearchForm;
